import { render, staticRenderFns } from "./CamperVan.vue?vue&type=template&id=61443654&"
import script from "./CamperVan.vue?vue&type=script&lang=ts&"
export * from "./CamperVan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports